import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformServer } from '@angular/common';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { ScrollService } from '@fcom/common/services';
import { RootPaths } from '@fcom/core/constants';

import { StateActions } from '../actions';
import { MmbStage } from '../../enums';

@Injectable()
export class StageEffects {
  stage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(StateActions.setStage.type),
        map((action) => {
          switch (action.stage) {
            case MmbStage.LOGIN: {
              this.router.navigate(['/', this.lang.langValue || 'en', ...RootPaths.MANAGE_BOOKING_ROOT.split('/')], {
                queryParamsHandling: 'merge',
              });
              this.scrollService.scrollTop();
              return;
            }
            case MmbStage.VIEW: {
              this.router.navigate(
                ['/', this.lang.langValue || 'en', ...RootPaths.MANAGE_BOOKING_ROOT.split('/'), 'view'],
                {
                  queryParams: {
                    lastName: null,
                    recLoc: null,
                    fromCheckIn: !!action.fromCheckIn,
                  },
                  fragment: this.router.parseUrl(this.router.url).fragment,
                  queryParamsHandling: 'merge',
                  replaceUrl: this.hasParam('lastName') && this.hasParam('recLoc'),
                }
              );
              this.scrollService.scrollTop();
              return;
            }
            case MmbStage.PASSENGERS: {
              this.router.navigate([
                '/',
                this.lang.langValue || 'en',
                ...RootPaths.MANAGE_BOOKING_ROOT.split('/'),
                'view',
                'passengers',
              ]);
              this.scrollService.scrollTop();
              return;
            }
            case MmbStage.CHECKOUT: {
              this.router.navigate(
                ['/', this.lang.langValue || 'en', ...RootPaths.MANAGE_BOOKING_ROOT.split('/'), 'checkout'],
                { skipLocationChange: true }
              );
              this.scrollService.scrollTop();
              return;
            }
            case MmbStage.CONFIRMATION: {
              if (!isPlatformServer(this.platform)) {
                this.router.navigate([
                  '/',
                  this.lang.langValue || 'en',
                  ...RootPaths.MANAGE_BOOKING_ROOT.split('/'),
                  'confirmation',
                ]);
                this.scrollService.scrollTop();
              }
              return;
            }
            default: {
              return;
            }
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions<StateActions.StateActionsUnion>,
    private router: Router,
    private lang: LanguageService,
    private scrollService: ScrollService,
    @Inject(PLATFORM_ID) private platform: Record<string, unknown>
  ) {}

  private hasParam(param: string) {
    return this.router.parseUrl(this.router.url).queryParamMap.has(param);
  }
}
